import React, { useState } from "react";
import { FaShieldAlt, FaCogs, FaLock, FaMinus, FaPlus, FaChartLine, FaFileInvoiceDollar,  FaVideo, FaHeadset, FaSync, FaLaptopMedical, FaServer, FaUserMd, FaHeartbeat, FaTabletAlt, FaRobot, FaHospitalUser, FaUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Footer from "../../../Component/Fooder";
import { motion } from 'framer-motion';
import Healthcare from "../../../assests/service/Healthcare.jpg";

const Telemedicine = () => {
    const navigate = useNavigate();
    const [openIndex, setOpenIndex] = useState(0);

    return (
        <>
            <div className="w-full bg-gray-50">
                {/* Hero Section */}
                <div
                    className="relative w-full h-[500px] bg-cover bg-center flex flex-col items-center justify-center text-white text-center px-4 mt-2"
                    style={{ backgroundImage: `url(${Healthcare})` }}
                >
                    <div className="absolute inset-0 bg-[rgba(8,3,3,0.7)]  backdrop-blur-none"></div>
                    <motion.div
                        className="relative z-10"
                        initial={{ opacity: 0, x: -100 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 1 }}
                    >
                        <h1 className="text-[30px] font-extrabold">Telemedicine Platform Integration</h1>
                        <p className="text-lg mt-4 text-white max-w-3xl">
                            At 1 Gs, We provide seamless Telemedicine platform integration services, enabling real-time virtual consultations, remote patient monitoring, and secure data exchange between EHRs, medical devices, and healthcare systems. Our solutions ensure HIPAA-compliant, high-quality video, audio, and messaging capabilities to enhance patient care and streamline workflows.
                        </p>
                        <button
                            className="mt-3 px-6 py-3 bg-white text-blue-700 font-semibold rounded-lg hover:bg-gray-200 transition"
                            onClick={() => navigate("/Contact")}
                        >
                            LET’S DISCUSS YOUR NEEDS
                        </button>
                    </motion.div>
                </div>

                <div className="bg-white max-w-full mx-auto py-16 px-6">                {/* How We Can Help Section */}
                    <section className="w-full mx-auto  px-2">
                        <h2 className="text-[30px] font-bold text-center flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">How We Can Help</h2>
                        <p className="text-gray-800 text-center text-sm mt-2">
                            Exchanging healthcare data is critical, but it can be complex. We simplify the process, ensuring smooth integration.
                        </p>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto px-4 mt-4">
                            {helpFeatures.map((feature, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                    transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <feature.icon className="text-[#2a627a] text-4xl mx-auto mb-4" />
                                    <h3 className="text-lg text-[#2a627a] font-bold">{feature.title}</h3>
                                    <p className="text-gray-800 text-sm mt-2">{feature.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Key Interoperability Services */}
                    <section className=" py-12">
                        <div className="w-full mx-auto  ">
                            <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">Key Services</h2>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4 max-w-5xl mx-auto px-4">
                                {services.map((service, index) => (
                                    <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-4 text-center hover:scale-105 transition-transform" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                        whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                        transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                        viewport={{ once: false, amount: 0.3 }}>
                                        <h3 className="text-lg font-bold text-[#2a627a]">{service.title}</h3>
                                        <p className="text-gray-800 text-sm mt-2">{service.description}</p>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Why Choose Us */}
                    <section className="w-full mx-auto ">
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">Why Choose Us?</h2>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-4 max-w-5xl mx-auto px-4">
                            {whyChooseUs.map((item, index) => (
                                <motion.div key={index} className="bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-lg rounded-xl p-6 text-center hover:scale-105 transition-transform"
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                    whileInView={{ opacity: 1, x: 0 }} // Move to center
                                    transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                    viewport={{ once: false, amount: 0.3 }}>
                                    <h3 className="text-lg font-bold text-[#2a627a]">{item.title}</h3>
                                    <p className="text-gray-800  text-sm mt-2">{item.description}</p>
                                </motion.div>
                            ))}
                        </div>
                    </section>
                    {/* Services Section */}
                    <section className="mt-12 w-full  mx-auto">
                        {/* Heading */}
                        <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                            Discover Our Services
                        </h2>

                        {/* Service List */}
                        <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                            {List.map((service, index) => (
                                <div key={index} className="border-b border-gray-800">
                                    {/* Service Title */}
                                    <button
                                        className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                        onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                    >
                                        {service.title}
                                        {openIndex === index ? (
                                            <FaMinus className="text-red-500" />
                                        ) : (
                                            <FaPlus className="text-gray-600" />
                                        )}
                                    </button>

                                    {/* Service Description (Expandable with Animation) */}
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3, ease: "easeInOut" }}
                                        className="overflow-hidden"
                                    >
                                        <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                    </motion.div>
                                </div>
                            ))}
                        </div>
                    </section>



                </div>
                {/* Contact Section */}
                <div className="w-full bg-[#2a627a] text-white py-12 text-center">
                    <h2 className="text-2xl font-bold">Ready to Transform Healthcare?</h2>
                    <p className="mt-2">Let’s collaborate to build seamless and secure healthcare solutions.</p>
                    <button
                        className="mt-4 px-6 py-3 bg-white text-[#2a627a] font-semibold rounded-lg hover:bg-gray-400 transition"
                        onClick={() => navigate("/Contact")}
                    >
                        Book Your Free Consultation
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

// Data for different sections
const helpFeatures = [
    {
        title: "Real-Time Virtual Consultations",
        description: "Enable secure, high-quality video, audio, and messaging for remote patient consultations.",
        icon: FaVideo
    },
    {
        title: "Remote Patient Monitoring",
        description: "Integrate with medical devices and EHRs for continuous patient health tracking.",
        icon: FaHeartbeat
    },
    {
        title: "Secure Data Exchange",
        description: "Ensure HIPAA-compliant data sharing between healthcare systems and telemedicine platforms.",
        icon: FaLock
    },
    {
        title: "Scalable Cloud Integration",
        description: "Leverage cloud-based telehealth solutions for remote access, data storage, and scalability.",
        icon: FaServer
    }
];


const services = [

    {
        title: "EHR & EMR Integration",
        description: "Seamlessly connect Telemedicine platforms with leading EHR/EMR systems for real-time access to patient data.",
        icon: FaHospitalUser
    },
    {
        title: "Secure Video & Audio Conferencing",
        description: "Implement HIPAA-compliant virtual consultation features with end-to-end encryption.",
        icon: FaVideo
    },
    {
        title: "Remote Patient Monitoring (RPM)",
        description: "Integrate wearable devices, IoT sensors, and mobile apps to track patient vitals remotely.",
        icon: FaHeartbeat
    },
    {
        title: "Custom Telehealth Portals",
        description: "Develop patient and provider dashboards, appointment scheduling, and secure chat functionality.",
        icon: FaUserMd
    },
    {
        title: "AI-Powered Symptom Assessment",
        description: "Leverage AI-driven chatbots and symptom-checker tools for pre-diagnosis and triage.",
        icon: FaRobot
    },
    {
        title: "Automated Billing & Insurance Verification",
        description: "Integrate medical billing, insurance claims, and e-prescriptions within Telemedicine platforms.",
        icon: FaFileInvoiceDollar
    },
    {
        title: "Multi-Device & Cross-Platform Compatibility",
        description: "Ensure smooth web, mobile, and cloud-based Telemedicine access.",
        icon: FaTabletAlt
    }
];

const whyChooseUs = [
    {
        title: "Seamless EHR Integration",
        description: "We integrate Telemedicine with EPIC, Cerner, eClinicalWorks, Athenahealth, and more.",
        icon: FaServer
    },
    {
        title: "HIPAA & HL7 Compliance",
        description: "Ensure secure, encrypted, and standardized healthcare data exchange.",
        icon: FaLock
    },
    {
        title: "Scalable & Customizable Solutions",
        description: "Tailored Telehealth solutions for hospitals, clinics, and startups.",
        icon: FaCogs
    },
    {
        title: "User-Friendly Interfaces",
        description: "Intuitive provider and patient dashboards for easy navigation.",
        icon: FaUserCircle
    },
    {
        title: "24/7 Support & Maintenance",
        description: "Continuous monitoring, troubleshooting, and performance optimization.",
        icon: FaHeadset
    }
];

const List = [
    
        {
            "title": "Virtual Consultation Integration",
            "description": "Seamlessly integrate secure video conferencing, real-time chat, and remote diagnostic tools into your telemedicine platform. Ensure a smooth patient-provider experience with high-quality video, encrypted communication, and automated appointment scheduling.",
            "icon": "FaVideo"
        },
        {
            "title": "Real-Time EHR Data Syncing",
            "description": "Enable instant synchronization of patient records, prescriptions, lab results, and treatment plans between Electronic Health Records (EHR) and telehealth platforms. Improve clinical decision-making with up-to-date patient information at every virtual visit.",
            "icon": "FaSync"
        },
        {
            "title": "Remote Monitoring & AI Analytics",
            "description": "Enhance patient care with AI-powered remote monitoring tools that track vital signs, detect anomalies, and generate predictive insights. Leverage machine learning algorithms for early disease detection and proactive intervention.",
            "icon": "FaChartLine"
        },
        {
            "title": "Custom Telemedicine Software Development",
            "description": "Design and develop bespoke, feature-rich telemedicine applications tailored to your organization’s needs. Incorporate custom workflows, patient portals, e-prescriptions, and billing solutions while ensuring seamless integration with existing healthcare systems.",
            "icon": "FaLaptopMedical"
        },
        {
            "title": "Regulatory Compliance & Security Audits",
            "description": "Ensure full compliance with healthcare regulations, including HIPAA, GDPR, HL7, and FHIR. Conduct security audits, implement end-to-end encryption, and deploy role-based access control to safeguard patient data and protect against cyber threats.",
            "icon": "FaShieldAlt"
        }
    ]
    


export default Telemedicine;
